<template>
  <div class="packing-holder">
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openCreateEditModal()">
            Nova embalagem
          </button>
        </div>
      </div>
      <div class="column is-12" v-if="packings.length > 0">
        <div class="table-holder">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Tamanho</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="packing in packings" :key="packing.id">
                <th>{{ packing.size | packingSize }}</th>
                <th class="options-holder">
                  <a class="option" @click="openCreateEditModal(packing)"
                    >Editar</a
                  >
                  <a class="option" @click="remove(packing)">Excluir</a>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">
          Nenhuma embalagem foi encontrada.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditPackingModal from "../components/packing/CreateEditPackingModal";
import NotificationsWrapper from "../helpers/NotificationsWrapper";

export default {
  name: "Packings",
  data: () => ({
    currentPage: 1,
    searchText: ""
  }),
  computed: {
    ...mapState({
      packings: state => state.packing.packings,
      isLoadingData: state => state.packing.loading,
      totalPages: state => state.packing.totalPages
    })
  },
  methods: {
    ...mapActions({
      getPackings: "packing/getPackings",
      removePacking: "packing/removePacking"
    }),
    ...mapMutations({
      resetFilters: "packing/resetFilters",
      setDriverFilters: "packing/setQueryFilters",
      setPage: "packing/setPage"
    }),
    openCreateEditModal(packing) {
      this.$modal.show(
        CreateEditPackingModal,
        { packingParam: Object.assign({}, packing) },
        { width: "700px", height: "auto", adaptive: true, scrollable: true, clickToClose: false },
        {
          closed: () => {
            this.getPackings();
          }
        }
      );
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.getPackings();
    },
    remove(packing) {
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir a embalagem ${this.$options.filters.packingSize(
          packing.size
        )}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removePacking(packing.id)
                .then(() => {
                  NotificationsWrapper.success(
                    "Embalagem excluída com sucesso!"
                  );
                  this.$modal.hide("dialog");
                  this.getPackings();
                })
                .catch(() => {
                  NotificationsWrapper.error(
                    "Não foi possível remover a embalagem!"
                  );
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    }
  },
  created() {
    this.getPackings();
    this.$store.commit("setSelectedViewTitle", "Embalagens");
  }
};
</script>

<style lang="scss" scoped></style>
